export const getInitials = (name: string) => {
  if (!name) return "User";

  return name[0].toUpperCase() + name[1];
};
